// Theme = a token swap. index.html applies the persisted value before first
// paint; this helper flips and persists it (same contract as the design docs:
// localStorage key `rp-theme`, `data-theme` on <html>).
export function currentTheme(): 'light' | 'dark' {
  return document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
}

export function toggleTheme(): 'light' | 'dark' {
  const next = currentTheme() === 'dark' ? 'light' : 'dark';
  document.documentElement.dataset.theme = next;
  localStorage.setItem('rp-theme', next);
  return next;
}
